import { HttpClient } from '@angular/common/http';
import { ElementRef, EventEmitter, HostListener, OnDestroy, Output } from '@angular/core';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { HistoryService } from '../../history';
import { BlockFile, BObjectModel, ContactMail, ModelMail, QueovalDate, QueovalDik, Recipient, SendMailModel } from '../../models';
import { Option } from '../../models/effectif/option.model';
import { CoreService, HttpService, QueovalDateService } from '../../services';
import { ToastService } from '../../toast';
import { b64EncodeUnicode } from '../../utilities';

declare var require: any;
const ClassicEditor: any = require('../../../../app-queoval/src/assets/ckeditor5/build/ckeditor');
declare var $: JQueryStatic;

@Component({
  selector: 'q-sendmail',
  templateUrl: './send-mail.component.html',
  styleUrls: ['./send-mail.component.css']
})

export class SendMailComponent implements OnInit, OnDestroy {


  public model: SendMailModel = new SendMailModel();
  /**
   * Ident pere pour les mails
   */
  public idPere: string;

  /**
   * Ident du client
   */
  public idClient: string;

  public type: string;

  public date: QueovalDate = new QueovalDate();
  public Editor: any = ClassicEditor;
  public ckDisabled: boolean=true;
  public contentMail: string = '';
  public contentSms: string = '';
  public Cc: boolean = false;
  public Cci: boolean = false;
  public Sms: boolean = false;

  public forceEdit: boolean = false;
  public ckeditorVersion: string = '4';
  public sender: string = '';
  public smsSender: string = '';
  public lstSmsSenders: Array<string> = new Array<string>();
  public listSms: Array<string> = [];
  public listRecipientTo: Array<string> = [];
  public listRecipientCc: Array<string> = [];
  public listRecipientBcc: Array<string> = [];
  public Object: string = '';

  public contacts: Array<Recipient> = [];
  public idContactSelected: string = '0';

  public modeles: Array<QueovalDik> = [];
  public selectedModel: string = '';

  public listDocuments: Array<BlockFile> = [];
  public customerDocuments: Array<BlockFile> = [];
  public localDocument: Array<BlockFile> = [];

  public listGroupDoc: Array<string> = [];

  public files: Array<BlockFile> = [];

  public envoyerAdestinataire: string = 'Envoyer à tous';
  public envoyerAdestinataireTooltip: string = 'Envoi groupé de tous les emails sans prévisualisation';

  public regexEmail: RegExp = /^\S+@\S+\.\S+$/;
  public regexSms: RegExp = /^(\+)?[0-9()-. ]+$/;

  public localFile: File | null;
  public localFileName: string = '';
  public accept: string = '.pdf, .doc, .docx, .xlsx, .xlsm, .xlsb, .jpg, .jpeg, .png';
  public extension: string = '';

  public localFileIsBeingExported: boolean = false;
  public mailIsSending: boolean = false;

  public attachmentToPdf: boolean = true;

  public subscribeDevisDocument: Subscription;

  // #region INPUT / OUTPUT

  @Input('model') set SetModel(value: SendMailModel) {
    this.model = value;
    this.contacts = this.model.RecipientList;
  }

  /**
   * Ident sur lequel est lié le mail (idpere)
   * identActionCo
   * identStage
   */
  @Input('Ident') set SetIdPere(value: string) {
    this.idPere = value;
  }
  
  /**
 * Liste des types existants actuellement :
 * ACTIONCO
 * STAGE
 */
  @Input('Type') set SetType(value: string) {
    this.type = value;
  }

  /**
   * Ident du client (optionnel)
   */
  @Input('IdClient') set SetIdClient(value: string) {
    this.idPere = value;
  }

    //  @Output() modelChange: EventEmitter<ActionCoCardModel> = new EventEmitter<ActionCoCardModel>();
  // @Output() setIdActionCo: EventEmitter<string> = new EventEmitter<string>();
  @Output() mailSend: EventEmitter<boolean> = new EventEmitter<boolean>();

  // #endregion

  @HostListener('window:click', ['$event'])
  ClosePopUp(event: any) {
    const popUpcontainer: HTMLElement = (document.getElementById('popUp') as HTMLElement);
    if (!$(event.target).closest(popUpcontainer).length && popUpcontainer) {
      popUpcontainer.classList.remove('d-block');
    }
    const paperclipPopUpcontainer: HTMLElement = (document.getElementById('paperclipPopUp') as HTMLElement);
    if (!$(event.target).closest(paperclipPopUpcontainer).length && paperclipPopUpcontainer) {
      paperclipPopUpcontainer.classList.remove('d-block');
    }
  }

  constructor(
    public indParam: CoreService,
    private http: HttpService,
    public toast: ToastService,
    public httpClient: HttpClient,
    public dateService: QueovalDateService,
    protected historyService: HistoryService
  ) { }

  ngOnInit() {
    const clientDB = this.indParam.ClientDB.slice(0, 11);
    const logged = `${this.indParam.AppParams.LoggedUser.NomfaPER} ${this.indParam.AppParams.LoggedUser.Pre01PER}`.slice(0, 11);
    if (clientDB)
      this.lstSmsSenders.push(clientDB);
    if (logged)
      this.lstSmsSenders.push(logged);
    if (this.model && this.model.SmsSendersList) {
      this.model.SmsSendersList.forEach(sender => this.lstSmsSenders.push(sender));
    }
    // type ACTIONCO uniquement -> récupération des contacts par rapport au client
    if (this.type === 'ACTIONCO') {
      if (this.model && this.model.IdClient && this.model.IdClient !== '0') {
        this.http.getHttp<SendMailModel>(`${this.indParam.AppParams.apiUrl}api/sendMail/GET_LIST_CONTACTS_BY_CUSTOMER/${this.model.IdClient}`).subscribe((result: SendMailModel) => {
          this.contacts = result.RecipientList;
          const index: number = this.contacts.findIndex(c => c.Ident === this.model.IdContactPrincipal);
          if (index > -1) {
            const element: Recipient = this.contacts[index];
            this.contacts.splice(index, 1);
            this.contacts.splice(0, 0, element);
          }
        });
      }
    }

    this.http.getHttp<SendMailModel>(`${this.indParam.AppParams.apiUrl}api/sendMail/GET_MODELES/${this.type}`).subscribe((result: SendMailModel) => {
      this.modeles = result.LstModelesMail;
    });

    if (this.idClient && this.idClient != '0') {
      this.http.getHttp<SendMailModel>(`${this.indParam.AppParams.apiUrl}api/sendMail/GET_CUSTOMER_DOCUMENT/${this.idClient}`).subscribe((result: SendMailModel) => {
        this.customerDocuments = result.ClientDocuments;
      });
    }

    this.GetListDocument();
  }

  ngOnDestroy(): void {
    this.model.SelectedModel = "";
    this.model.IdContactPrincipal = "";
  }

  public OnContactSelected(selectContact: string) {
    const contact: Recipient | undefined = this.contacts.find((contact) => contact.Ident === selectContact);
    const name = contact ? ` à ${contact.Value}` : '';
    this.model.Destinataire = contact ? contact.Value : '';
    this.envoyerAdestinataire = selectContact == '0' ? 'Envoyer à tous' : `Envoyer${name}`;
    this.envoyerAdestinataireTooltip = selectContact == '0' ? 'Envoi groupé de tous les emails sans prévisualisation' : `Prévisualiser l'email avant de l'envoyer${name}`;
    this.model.IdContactPrincipal = selectContact;
    this.OnModelChange(this.model.SelectedModel);
    this.ckDisabled = selectContact == '0';
  }


  public OnModelChange(value: string) {
    //filtre la liste au changement du destinataire ou du model pour ne garder que les documents génériques (pièces jointes)
    this.files = this.files.filter((document) => document.group != 'DOCUMENT_AUTO');
    this.forceEdit = false;
    this.model.SelectedModel = value;
    if (value) {
      this.indParam.showSplash(true);
      const model: SendMailModel = this.model;
      model.IdPere = this.idPere;
      model.type = this.type;
      model.Mode = "PREVIEW_MODEL";
      // si il n'existe qu'une personne selectionnable
      if (this.contacts.length == 1) {
        const contact: Recipient = this.contacts[0];
        this.idContactSelected = contact.Ident;
        this.model.Destinataire = contact.Value;
        this.envoyerAdestinataire = `Envoyer à ${contact.Value}`;
        this.envoyerAdestinataireTooltip = `Prévisualiser l'email avant de l'envoyer à ${contact.Value}`;
        this.model.IdContactPrincipal = this.idContactSelected;        
      }

      this.http.postHttp<SendMailModel>(`${this.indParam.AppParams.apiUrl}api/sendMail/`, model).subscribe(
        (result: SendMailModel) => {
          this.contentMail = result.Model.ContentMail;
          this.listRecipientTo = result.Model.To ? result.Model.To : [];
          this.listRecipientCc = result.Model.CC ? result.Model.CC : [];
          this.Cc = this.listRecipientCc.length > 0;
          this.listRecipientBcc = result.Model.CCI ? result.Model.CCI : [];
          this.Cci = this.listRecipientBcc.length > 0;
          this.Object = result.Model.Object;
          this.sender = result.Model.SenderMail.replace(/ /g, '');
          this.ckeditorVersion = result.Model.CkeditorVersion;
          this.indParam.showSplash(false);
          if (result.ListDocuments && result.ListDocuments.length > 0) {
            if (this.files) {
              this.files = this.files.concat(result.ListDocuments);
            }
            else {
              this.files = result.ListDocuments;
            }
          }

          // Si il n'y a qu'un destinaire alors on active le ckeditor
          if (this.contacts.length == 1)
            this.ckDisabled = false;
        });
    }
    //cas ou la select du model de document est égal à null || undefined
    else {
      this.files = this.files.filter((document) => document.group != 'DOCUMENT_AUTO');
      this.contentMail = "";
      this.model.SelectedModel = "";
      this.idContactSelected = "0";
      this.model.IdContactPrincipal = "";

      this.listRecipientTo = [];
      this.listRecipientCc = [];
      this.listRecipientBcc = [];
      this.Object = '';
      this.sender = '';
      this.Cc = false;
      this.Cci = false;

      this.envoyerAdestinataire =  'Envoyer à tous';
      this.envoyerAdestinataireTooltip = 'Envoi groupé de tous les emails sans prévisualisation';
      this.ckDisabled = true;
    }
  }

  public openPopUp(event: MouseEvent, popUp: string) {
    event.stopPropagation();
    (document.getElementById(popUp) as HTMLElement).classList.toggle('d-block');
    switch (popUp) {
      case 'popUp':
        this.closePopUpPaperclip();
        break;
      case 'paperclipPopUp':
        this.closePopUpScheduledSending();
        break;
    }
  }

  public AccordionClicked(element: HTMLElement) {
    element.classList.toggle("active");
    const panel: any = (element.nextElementSibling as HTMLDivElement);
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = "100000000000000000000000000000000000000000000000000000000000px";
    }
  }

  public ToggleFile(event: any, file: BlockFile): void {
    if (event != null) { event.stopPropagation(); }

    const index: number = this.files.findIndex(f => f.value === file.value && f.key === file.key);
    if (index > -1) {
      file.selected = false;
      this.files.splice(index, 1);
    } else {
      file.selected = true;
      this.files.push(file);
    }
  }

  public ToggleInputButton(element: HTMLElement, action: string): void {
    switch (action) {
      case 'edit':
        $(element).each(function () {
          const parent = this.parentElement;
          (parent as HTMLElement).style.display = 'none';
          ((parent as HTMLElement).nextElementSibling as HTMLElement).style.display = 'flex';
          const inputElement: HTMLInputElement = (((parent as HTMLElement).nextElementSibling as HTMLElement).children[0] as HTMLInputElement);
          inputElement.focus();
          inputElement.selectionStart = inputElement.selectionEnd = 10000;
        });
        break;
      case 'view':
        $(element).each(function () {
          if ($(this).parent().parent().parent().hasClass('wrong-email')) {
            $(this).parent().parent().parent().removeClass('wrong-email');
          }
          const regexMail: RegExp = /^\S+@\S+\.\S+$/;
          if (regexMail.test((this as HTMLInputElement).value)) {
            const parent = this.parentElement;
            (parent as HTMLElement).style.display = 'none';
            ((parent as HTMLElement).previousElementSibling as HTMLElement).style.display = 'flex';
          } else {
            $(this).focus();
            (this as HTMLInputElement).selectionStart = (this as HTMLInputElement).selectionEnd = 10000;
            $(this).parent().parent().parent().addClass('wrong-email');
          }
        });
        break;
    }
  }

  public RemoveItemFromList(index: number, list: Array<any>): void {
    list.splice(index, 1);
  }
  public AddItemToList(event: any, list: Array<string>): void {
    if ($(event.target).parent().hasClass('wrong-email')) {
      $(event.target).parent().removeClass('wrong-email');
    }
    if (event.key === ' ' || event.key === 'Tab' || event.key === 'Enter') {
      const regexMail: RegExp = /^\S+@\S+\.\S+$/;
      event.target.value = (event.target.value as any).replaceAll(' ', '');
      if (regexMail.test(event.target.value)) {
        list.push(event.target.value);
      } else {
        $(event.target).parent().addClass('wrong-email');
      }
    }
  }

  public trackByFn(index: number, item: any) {
    return index;
  }

  public SendMail(isProgramed: boolean): void {
    if (isProgramed) {
      if (this.dateService.IsNull(this.date)) {
        this.toast.showInfoToast('Veuillez renseigner une date valide.');
        return;
      }
      const invalidDate: boolean = this.dateService.Compare(this.date, '<=', this.dateService.Now())
      if (invalidDate) {
        this.toast.showInfoToast('Veuillez renseigner une date supérieure à la date du jour.');
        return;
      }
    }

    if ((this.model.SelectedModel == undefined || this.model.SelectedModel == '') && !this.Sms) {
      this.toast.showInfoToast(`veuillez sélectionner un modèle de mail.`);
      return;
    }

    // Si un contact est selectionne, on vérifie si des destinanire et expediteur existe.
    // Dans le cas Envoyer à tous pas de vérification
    if (this.model.IdContactPrincipal && this.model.IdContactPrincipal !== '0') {

      if ((!this.sender && !this.Sms) || (!this.smsSender && this.Sms)) {
        this.toast.showInfoToast(`veuillez renseigner l'expéditeur.`);
        return;
      }

      if (
        ((!this.model.RecipientList || this.model.RecipientList.length === 0) &&
          (!this.listRecipientTo || this.listRecipientTo.length < 1) &&
          (!this.Cc || !this.listRecipientCc || this.listRecipientCc.length < 1) &&
          (!this.Cci || !this.listRecipientBcc || this.listRecipientBcc.length < 1) &&
          !this.Sms)
        ||
        (this.Sms && (!this.listSms || this.listSms.length < 1))
      ) {
        this.toast.showInfoToast(`veuillez renseigner au moins un destinataire.`);
        return;
      }

    }

    const model: SendMailModel = this.model;
    model.type = this.type;
    this.mailIsSending = true;
    model.AttachmentToPdf = this.attachmentToPdf;
    if (this.Sms) {
      model.Mode = 'SEND_SMS';
      const smss: Array<string> = [];
      this.listSms.forEach((sms: string) => {
        if (!sms.startsWith('+')) {
          smss.push(`+33${sms.slice(1)}`.replace(/ /g, '').replace(/\./g, '').replace(/-/g, '').replace(/\(/g, '').replace(/\)/g, ''));
        } else {
          smss.push(sms.replace(/ /g, '').replace(/\./g, '').replace(/-/g, '').replace(/\(/g, '').replace(/\)/g, ''));
        }
      });
      model.Model.To = smss;
      model.Model.ContentMail = this.contentSms;
      var letterNumber = /^[0-9a-zA-Z]+$/;
      var Number = /^[0-9]+$/;
      if ((!Number.test(this.smsSender) && letterNumber.test(this.smsSender) && this.smsSender.length > 11) || (Number.test(this.smsSender) && this.smsSender.length > 15)) {
        this.mailIsSending = false;
        this.toast.showInfoToast(`l'expéditeur est limité à 11 caractères alphanumériques ou 15 numériques.`);
        return;
      }

      model.Model.SenderMail = this.smsSender;
    } else {
      // 2 modes possibles d'envoi de mail selon si on a un contact principal sélectionné ou non
      if (this.model.IdContactPrincipal && this.model.IdContactPrincipal !== '0') {
        // 1- Envoie du mail visualisé
        model.Mode = 'SEND_MAIL';
        model.Model = new ModelMail();
        model.Model.SenderMail = this.sender;
        model.Model.ContentMail = this.contentMail;
        model.Model.To = this.listRecipientTo;
        model.Model.CC = this.Cc ? this.listRecipientCc : [];
        model.Model.CCI = this.Cci ? this.listRecipientBcc : [];
        model.Model.Object = this.Object;
      }
      else {
        if (!this.model.RecipientList || this.model.RecipientList.length === 0) {
          this.toast.showAlertToast('Veuillez sélectionner au moins 1 destinataire');
        }
        else {
          model.Mode = 'SEND_MAIL_AUTO';
          model.Model = new ModelMail();
          model.Model.CC = this.Cc ? this.listRecipientCc : [];
          model.Model.CCI = this.Cci ? this.listRecipientBcc : [];
          model.ListDocAffected = this.model.ListDocAffected;
          this.files = this.files.filter((document) => document.group != 'DOCUMENT_AUTO');
        }
      }

      if (this.files && this.files.length > 0) {
        model.Attachments = {};
        this.files.forEach((file: { key: string, value: string, selected: boolean }) => {
          model.Attachments[file.value] = file.key;
        });
      }
    }
    if (isProgramed) {
      model.Programed = this.date;
    }

    // Ajout de données pour l'historique
    model.IdClient = this.idClient;
    model.IdPere = this.idPere;

    this.http.postHttp<SendMailModel>(`${this.indParam.AppParams.apiUrl}api/sendMail/`, model).subscribe((result: SendMailModel) => {
      this.mailIsSending = false;
      if (result.MsgSendMailAuto) {
        this.toast.showInfoToast(result.MsgSendMailAuto);
      }
      // mise à jour de l'historique et envoie de l'emitter
      this.historyService.GetHistory(this.idPere).subscribe(() => { this.mailSend.emit(true); });
    });
  }

  public CopyToClipBoard(value: string): void {
    var input = document.createElement('textarea');
    input.innerHTML = value;
    input.value = value;
    document.body.appendChild(input);
    input.select();
    input.focus();
    input.setSelectionRange(0, 99999); /* For mobile devices */
    var result = document.execCommand('copy');
    navigator.clipboard.writeText(input.value);
    document.body.removeChild(input);
    this.toast.showInfoToast('lien copié dans le presse-papiers')
  }

  public onSelectLocalFileChange(e: any): void {
    this.localFile = null;
    const file: File = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    const SplitFile: Array<string> = file.name.split('.');
    const extension: string = SplitFile[SplitFile.length - 1].toLowerCase();
    const extensionAccepted: Array<string> = this.accept.toLowerCase().replace(/\.| /g, '').split(',');
    if (extensionAccepted.includes(extension)) {
      this.extension = extension;
      this.localFile = file;
      this.localFileName = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
    } else {
      this.toast.showAlertToast(`${this.indParam.getTrad('InvalidFormat')} ${this.accept})`);
    }
  }

  public OnFileSave(e: any): void {
    e.stopPropagation();
    if (this.localFile === null) {
      this.toast.showInfoToast("aucun fichier reconnu n'est sélectionné.");
      return;
    }
    this.localFileIsBeingExported = true;
    const blob: Blob = this.localFile.slice(0, this.localFile.size, this.localFile.type);
    this.localFileName = this.localFileName.trim();
    this.localFile = new File([blob], this.localFileName, { type: this.localFile.type });
    if (this.localFile === undefined || this.localFile === null) {
      this.toast.showInfoToast("aucun fichier reconnu n'est sélectionné.");
      return;
    }

    const model: SendMailModel = this.model;
    model.Mode = 'ADD_BO_DOCUMENT';
    model.NewDocument = new BlockFile();
    model.NewDocument.fileName = this.localFileName;
    model.NewDocument.extension = this.extension;
    model.NewDocument.value = this.idPere;
    model.type = this.type;

    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/sendMail/`, model).subscribe((result: SendMailModel) => {
      this.localFileName = this.localFileName.endsWith(`.${this.extension}`) ? this.localFileName : `${this.localFileName}.${this.extension.trim()}`;

      const localFileName: string = b64EncodeUnicode(this.localFileName);
      //const originFileName: string = b64EncodeUnicode(origin);
      const fileName: string = b64EncodeUnicode((this.localFile as File).name);

      if (model.type == 'ACTIONCO')
        this.model.IdClient = result.IdClient;

      const ConfigFile: any = {
        responseType: 'arraybuffer' as 'arraybuffer',
        headers: { 'Queoval': this.indParam.AppParams.token, 'mode': 'INSERTDOC', 'fileName': localFileName, 'IdDonnee': result.BoDocAdded.value, 'IdRelation': result.BoDocAdded.key }
      };

      const formData: FormData = new FormData();
      formData.append('file', (this.localFile as File), fileName);
      formData.append('name', localFileName);
      formData.append('IDDONNEE', result.BoDocAdded.value);
      formData.append('IDRELATION', result.BoDocAdded.key);
      formData.append('ISCHILD', 'TRUE');
      formData.append('mode', 'INSERTDOC');
      formData.append('token', this.indParam.AppParams.token);

      this.httpClient.post(`${this.indParam.AppParams.apiUrl}api/Upload`, formData, ConfigFile).subscribe((data: any) => {
        const file = new BlockFile();
        file.key = this.localFileName;
        file.value = result.BoDocAdded.value;
        file.selected = true;
        file.isWebLink = false;
        file.extension = `.${this.extension}`;
        file.fileName = (this.localFile as File).name.toLocaleLowerCase().endsWith(`.${this.extension}`) ? (this.localFile as File).name.substring(0, (this.localFile as File).name.lastIndexOf(`.${this.extension}`)) : (this.localFile as File).name;

        switch (this.type) {
          case 'STAGE':
            file.group = 'Document'
            break;
          default:
            break;
        }

        this.files.push(file);
        this.localDocument.push(file);
        // Pour savoir dans quelle liste l'ajouter on regarde s'il y a l'ident du client renseigné
        if (this.model.IdClient) {
          this.customerDocuments.push(file);
        }
        else {
          this.listDocuments.push(file);
        }

        this.localFile = null;
        this.localFileName = '';
        this.localFileIsBeingExported = false;
      },
        (error: any) => {
          const deletemodel: SendMailModel = this.model;
          deletemodel.Mode = 'DELETE_BO_DOCUMENT';
          deletemodel.BoDocAdded = result.BoDocAdded;
          this.http.postHttp<SendMailModel>(`${this.indParam.AppParams.apiUrl}api/sendMail/`, deletemodel).subscribe();
          console.error(JSON.stringify(error));
          this.toast.showAlertToast('Une erreur est survenue lors de la création du fichier.');
          this.localFile = null;
          this.localFileName = '';
          this.localFileIsBeingExported = false;
        });

    });

  }

  public getIdContactPricipal(): string {
    let idContact = '';
    if (this.model) {
      idContact = this.model.IdContactPrincipal;
    }
    return idContact
  }

  public addAllMail(): void {
    this.contacts.forEach((contact: Recipient) => {
      if (contact.Mails.length > 0 && !this.listRecipientTo.includes(contact.Mails[0]?.value) && contact.Mails[0]?.value !== '') {
        this.listRecipientTo.push(contact.Mails[0].value);
      }
    });
    this.listRecipientTo = JSON.parse(JSON.stringify(this.listRecipientTo));
  }





  private closePopUpScheduledSending(): void {
    (document.getElementById('popUp') as HTMLElement).classList.remove('d-block')
  }
  private closePopUpPaperclip(): void {
    (document.getElementById('paperclipPopUp') as HTMLElement).classList.remove('d-block')
  }

  private GetListDocument(): void {
    if (this.idPere && this.idPere !== '0' && this.type) {
      // Récupération des documents selon le type
      this.http.getHttp<SendMailModel>(`${this.indParam.AppParams.apiUrl}api/sendMail/GET_DOCUMENTS_${this.type}/${this.idPere}`).subscribe((result: SendMailModel) => {
        this.listDocuments = result.ListDocuments;
        this.listGroupDoc = result.ListGroupDoc;
      });
    }
  }
}
